/* eslint radix: ["off"] */

import React, { Component } from 'react';
import isFunction from 'lodash/isFunction';
import './ClientList.css';
import GroupsFilter from './GroupsFilter';
import { inject, observer } from 'mobx-react';
import { List } from 'antd';
import ClientListItem from './ClientListItem';
import { withWindowSize } from 'air-with-window-size';

@inject('translationsStore', 'carsStore')
@observer
class ClientList extends Component {
  constructor(props) {
    super(props);

    this.state = { selected: false };

    this.ClientListRef = React.createRef();
  }

  highlight(car = {}) {
    this.setState({ highlight: car.id });
  }

  select(car = {}) {
    this.setState({ selected: (car || {}).id });
  }

  onClick = car => e => {
    if (isFunction(this.props.onClick)) {
      this.props.onClick(car, e);
    }
  };

  onMouseEnter = car => e => {
    if (isFunction(this.props.onMouseEnter)) {
      this.props.onMouseEnter(car, e);
    }
  };
  onMouseLeave = car => e => {
    if (isFunction(this.props.onMouseLeave)) {
      this.props.onMouseLeave(car, e);
    }
  };

  onGroupChange = value => {
    if (isFunction(this.props.onGroupChange)) {
      this.props.onGroupChange(value);
    }
  };

  updatePageSize() {
    let deltaHeight = this.props.windowHeight - 800;
    if (deltaHeight < 0) {
      deltaHeight = deltaHeight + 48;
    }

    this.props.onPageListChange(1, 7 + Math.floor(deltaHeight / 80));
  }

  componentDidMount = () => {
    this.updatePageSize();
    this.updateCurrentPage();
  };

  updateCurrentPage() {
    const { clientId, cars, simpleMapCars } = this.props;
    if (clientId) {
      const position = simpleMapCars.findIndex(car => parseInt(car.id) === parseInt(clientId)) + 1;
      this.props.onPageListChange(Math.ceil(position / this.props.pageSize), this.props.pageSize);
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.pageSize !== this.state.pageSize) {
      this.updateCurrentPage();
    }

    if ((this.props.cars || []).length !== (prevProps.cars || []).length && Math.min(this.props.pageSize * (this.props.page - 1) + this.props.pageSize, this.props.carsCount) < this.props.carsCount) {
      this.props.onPageListChange(1, this.props.pageSize);
    }

    if (prevProps.windowHeight !== this.props.windowHeight) {
      this.updatePageSize();
    }
  };

  render() {
    const { cars, carsCount, page, pageSize, translationsStore, groups } = this.props;
    return (
      <div className="ClientList" ref={this.ClientListRef}>
        <List
          itemLayout="vertical"
          size="large"
          header={
            <div className="header">
              <GroupsFilter groups={groups} onChange={this.onGroupChange} />
              <div className="totals">
                <div>{pageSize * (page - 1) + 1} </div>
                <div className="dash">-</div>
                <div>{Math.min(pageSize * (page - 1) + pageSize, carsCount)} </div>
                <div>{translationsStore.translate('of')}</div>
                <div>{carsCount}</div>
                <div>{translationsStore.translate('vehicles')}</div>
              </div>
            </div>
          }
          pagination={{
            position: 'top',
            pageSize,
            simple: true,
            size: 'small',
            current: page,
            total: carsCount,
            hideOnSinglePage: true,
            onChange: page => {
              this.props.onPageListChange(page, pageSize);
            }
          }}
          dataSource={cars}
          renderItem={car => (
            <List.Item
              key={car.id}
              onMouseEnter={this.onMouseEnter(car)}
              onMouseLeave={this.onMouseLeave(car)}
              onClick={this.onClick(car)}
              className={`listItem ${!!car.lastPositionPoint ? 'withPosition' : ''} ${this.state.selected === car.id ? 'selected' : ''} `}
            >
              <ClientListItem car={car} showMap={this.props.showMap} />
            </List.Item>
          )}
        />
      </div>
    );
  }
}

export default withWindowSize(ClientList);



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientList/ClientList.js